const en: Record<string, string> = {
  // Navbar
  "nav.search": "Search",
  "nav.dubai": "Dubai",
  "nav.saudi": "Saudi Arabia",
  "nav.qatar": "Qatar",
  "nav.kuwait": "Kuwait",
  "nav.oman": "Oman",
  "nav.bahrain": "Bahrain",
  "nav.turkey": "Turkey",
  "nav.pakistan": "Pakistan",
  "nav.israel": "Israel",
  "nav.donateInfants": "Donate to Infants",
  "nav.influencers": "Influencers",
  "nav.howItWorks": "How It Works",
  "nav.registerFactory": "Register Factory",
  "nav.rfq": "RFQ",
  "nav.dashboard": "Dashboard",
  "nav.requestQuote": "Request Quote",
  "nav.browseByCountry": "Browse by Country",
  "nav.more": "More",
  "nav.searchFactories": "Search Factories",
  "nav.influencerProgram": "Influencer Program",
  "nav.supplierDashboard": "Supplier Dashboard",
  "nav.factoryBuyer": "Factory & Buyer",
  "nav.home": "Home",
  "nav.register": "Register",
  "nav.countries": "Countries",
  "nav.selectCountry": "Select a country to explore factories",

  // Hero
  "hero.badge": "5 Million+ Verified Factories · Middle East & Global",
  "hero.headline1": "Many Global Buyers",
  "hero.headline2": "Place Tens of Containers",
  "hero.headline3": "Per Year",
  "hero.subheadline": "from Our SuperMiddleEast Verified Factories",
  "hero.tagline": "Global Stars together help verified factories sell to the world —",
  "hero.tagline2": "bulk buyers, drop shippers, and influencers all in one platform.",
  "hero.searchPlaceholder": "Search products, suppliers...",
  "hero.allCategories": "All Categories",
  "hero.electronics": "Electronics",
  "hero.textiles": "Textiles",
  "hero.machinery": "Machinery",
  "hero.food": "Food & Beverage",
  "hero.furniture": "Furniture",
  "hero.beauty": "Beauty & Care",
  "hero.allCountries": "All Countries",
  "hero.search": "Search",
  "hero.dropshippingProducts": "Dropshipping Products",
  "hero.verifiedSuppliers": "Verified Suppliers",
  "hero.registerSupplier": "Register as Supplier",
  "hero.influencerCatalog": "Influencer Catalog",

  // Trust Banner
  "trust.verifiedFactories": "Verified Factories",
  "trust.countriesServed": "Countries Served",
  "trust.dropshippingReady": "Dropshipping Ready",
  "trust.influencerPartners": "Influencer Partners",

  // Categories
  "categories.label": "Browse by Category",
  "categories.title": "Explore Product Categories",
  "categories.subtitle": "From electronics to textiles — find verified suppliers across every industry",
  "categories.viewSuppliers": "View Suppliers",
  "categories.products": "products",

  // Country Factories Section
  "factories.subtitle": "Sample orders, bulk orders, and dropshipping — all from one platform. Every factory is verified by our team.",
  "factories.registerFactory": "Register Your Factory",
  "factories.viewAll": "View All Factories",
  "factories.verifiedFactories": "Verified Factories",
  "factories.dropshippingReady": "Dropshipping Ready",
  "factories.productsListed": "Products Listed",
  "factories.warehouseCountries": "Warehouse Countries",
  "factories.allFactories": "All Factories",
  "factories.verifiedOnly": "✓ Verified Only",
  "factories.dropshippingOnly": "🚚 Dropshipping Only",
  "factories.searchPlaceholder": "Search factories or categories...",
  "factories.howToOrder": "How to Order",
  "factories.step1": "Browse factories & products",
  "factories.step2": "Choose Sample or Bulk order",
  "factories.step3": "Set quantity & confirm",
  "factories.step4": "Factory ships to you",
  "factories.noResults": "No factories match your search.",
  "factories.ctaTitle": "Are You a Factory Owner?",
  "factories.ctaSubtitle": "List your products, set your prices, and start receiving sample & bulk orders from global buyers today.",
  "factories.howItWorks": "How It Works",

  // Dropshipping Section
  "dropship.label": "Dropshipping Program",
  "dropship.title1": "Start Dropshipping with",
  "dropship.title2": "Zero Inventory",
  "dropship.desc": "Partner with 5 million verified Middle East and Asian factories. Sell globally without holding stock — we handle fulfillment, you handle sales.",
  "dropship.benefit1": "Direct shipping from verified factories",
  "dropship.benefit2": "Local warehouse options in 50+ countries",
  "dropship.benefit3": "Influencer-curated product collections",
  "dropship.benefit4": "Zero inventory risk for dropshippers",
  "dropship.browseBtn": "Browse Dropship Products",
  "dropship.howBtn": "How It Works",
  "dropship.stat1": "Dropship Products",
  "dropship.stat2": "Local Warehouses",
  "dropship.stat3": "Avg. Processing",
  "dropship.stat4": "Delivery Success",

  // Footer
  "footer.tagline": "Connecting 5 million verified factories with global buyers. Dropshipping ready, influencer-powered.",
  "footer.stayUpdated": "Stay Updated",
  "footer.emailPlaceholder": "Your email address",
  "footer.join": "Join",
  "footer.thankYou": "Thank you for subscribing!",
  "footer.marketplace": "Marketplace",
  "footer.findSuppliers": "Find Suppliers",
  "footer.browseProducts": "Browse Products",
  "footer.dropshippingHub": "Dropshipping Hub",
  "footer.verifiedFactories": "Verified Factories",
  "footer.countryPages": "Country Pages",
  "footer.forSuppliers": "For Suppliers",
  "footer.registerSupplier": "Register as Supplier",
  "footer.verificationProcess": "Verification Process",
  "footer.pricingPlans": "Pricing Plans",
  "footer.influencerProgram": "Influencer Program",
  "footer.sellerResources": "Seller Resources",
  "footer.contactUs": "Contact Us",
  "footer.headquarters": "Headquarters",
  "footer.address": "Dubai World Trade Centre\nSheikh Zayed Road, Dubai, UAE",
  "footer.rights": "© 2026 SuperMiddleEast · All rights reserved",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
};

export default en;
